<template>
  <router-link :to="localeLink(path)">
    <div class="md:flex py-5">
      <div class="md:w-2/5 flex-none">
        <div class="text-xl lg:text-3xl uppercase">
          <base-dates :item="item" :years="false" months="MMMM"/>
        </div>
        <p class="serif" :class="{ song: isChinese}">
          <base-time-text :item="item" :mark="true"/>
        </p>
      </div>
      <div class="md:w-3/5 flex-1 truncate">
        <div class="text-2xl lg:text-3xl truncate w-full">{{ title }}</div>
        <p class="serif md:truncate">
          <span class="uppercase">{{ type }}</span>
          <!-- <span>{{ item.location }}</span> -->
        </p>
      </div>
    </div>
  </router-link>
</template>

<script>
export default {
  name: 'NowRowItem',
  props: {
    item: {
      type: Object,
      required: true
    }
  },
  computed: {
    isChinese () {
      return this.$store.state.locale === 'cn'
    },
    title () {
      return this.item.title
    },
    type () {
      return this.item.type
    },
    path () {
      return '/' + this.item.uri
    }
  }
}
</script>
